import { VStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { IconMail, IconPdf } from '../icons'
import { TextBody, TextBodyBold2 } from '../common/Text'
import Link from '../common/Link'
import SVG from '../common/SVG'
import useLocalize from '../../hooks/useLocalize'

export type FooterPressContactProps = BoxProps & {}

const FooterPressContact: React.FC<FooterPressContactProps> = ({ ...others }) => {
  const localize = useLocalize()
  return (
    <>
      <Box {...others}>
        <VStack spacing="5px" alignItems="flex-start">
          <Box>
            <TextBodyBold2 localizeKey="nav__title__press_contact" />
          </Box>
          <Box>
            <TextBody as="span" localizeKey="nav__body__press_contact_1" />
          </Box>
          <Box>
            <SVG svg={<IconMail />} w="15px" mr="0.5em" />
            <Link to={`mailto:${localize('nav__body__press_contact_2')}`}>
              <TextBody as="span" localizeKey="nav__body__press_contact_2" />
            </Link>
          </Box>
          <Box display="flex" alignItems="flex-start">
            <SVG svg={<IconPdf />} w="15px" mr="0.5em" mt="0.25em" />
            <TextBody as="span" localizeKey="nav__body__press_contact_3" />
          </Box>
        </VStack>
      </Box>
    </>
  )
}

export default FooterPressContact
